export default {
    props: {
        productData: {
            type: Object,
            required: true,
        },
        variantData: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {}
}
